import { render, staticRenderFns } from "./ResetPasswordLog.vue?vue&type=template&id=b44fb9ac&scoped=true&"
import script from "./ResetPasswordLog.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordLog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44fb9ac",
  null
  
)

export default component.exports